import { useEffect } from 'react'

import useUserData from 'components/common/hooks/useUserData'
import { identifyUser } from 'utils/mixpanel'

/**
 * ENGG-10414 — tells Mixpanel who the signed-in admin is. Mounted next to
 * FullStory (same recordingAllowed gate), reads the same cache-only user.
 * Renders nothing. Sign-out is handled where it happens (resetAnalytics in the
 * logout); utils/mixpanel decides what an impersonated session may send.
 */
const Analytics = () => {
  const user = useUserData()
  const userId = user.id
  const clientId = user.clientId ?? user.mainClient?.id
  const clientName = user.mainClient?.name
  const role = user.role?.roleType
  const isTangeloStaff = user.dsrSuperAdminSession
  const impersonating = user.impersonationContext?.impersonating

  useEffect(() => {
    if (!userId) return
    identifyUser({
      id: userId,
      clientId,
      clientName,
      role,
      isTangeloStaff,
      impersonating,
    })
  }, [userId, clientId, clientName, role, isTangeloStaff, impersonating])

  return null
}

export { Analytics }
